(function () {
  var keys = ['gclid', 'fbclid'];
  var prefix = 'fonteyn-click-id-';
  var lifetime = 30 * 24 * 60 * 60 * 1000;
  var params = new URLSearchParams(window.location.search);
  var ids = {};
  var observed = new WeakSet();

  keys.forEach(function (key) {
    var current = params.get(key);
    try {
      if (current) {
        localStorage.setItem(prefix + key, JSON.stringify({ value: current, expires: Date.now() + lifetime }));
      } else {
        var saved = JSON.parse(localStorage.getItem(prefix + key) || 'null');
        if (saved && saved.expires > Date.now() && typeof saved.value === 'string') {
          current = saved.value;
        } else {
          localStorage.removeItem(prefix + key);
        }
      }
    } catch (error) {}
    ids[key] = current || '';
  });

  function fillForm(form) {
    keys.forEach(function (key) {
      var input = Array.from(form.querySelectorAll('input')).find(function (field) {
        return field.name === 'values[' + key + ']' ||
          (field.dataset.key || '').toLowerCase() === key ||
          (field.dataset.label || '').toLowerCase() === key;
      });
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'values[' + key + ']';
        input.dataset.key = key;
        input.dataset.label = key;
        input.dataset.type = 'hidden';
        input.className = 'formful__input';
        form.appendChild(input);
      }
      if (input.value === ids[key]) return;
      input.value = ids[key];
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function fillBlock(block) {
    block.querySelectorAll('form').forEach(fillForm);
  }

  function init() {
    document.querySelectorAll('[data-ft-click-id-form]').forEach(function (block) {
      fillBlock(block);
      if (observed.has(block)) return;
      observed.add(block);
      new MutationObserver(function () { fillBlock(block); }).observe(block, { childList: true, subtree: true });
    });
  }

  document.addEventListener('submit', function (event) {
    if (event.target.matches('form') && event.target.closest('[data-ft-click-id-form]')) {
      fillForm(event.target);
    }
  }, true);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
